import { faLanguage } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { Navbar, NavDropdown } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { ILogo, Languages } from './types'

export function buildLogo({ href, src, width, height, className, alt }: ILogo) {
    return (
        <Navbar.Brand>
            <Link to={href}>
                <img src={src} width={width} height={height} className={className} alt={alt} />
            </Link>
        </Navbar.Brand>
    )
}

function dropdownItemForLangs(i18nLangs: Languages, language: string, key: number, onLangChange: any) {
    function onButtonClick(lang: string) {
        return () => onLangChange(lang)
    }

    return (
        <NavDropdown.Item onClick={onButtonClick(language)} key={key}>
            {i18nLangs[language]}
        </NavDropdown.Item>
    )
}

export function dropdownForLangs(i18nLangs: Languages, currentLangKey: string, onLangChange: any) {
    const title = (
        <span>
      <FontAwesomeIcon size={'lg'} icon={faLanguage} />
            {i18nLangs[currentLangKey]}
    </span>
    )

    return (
        <NavDropdown renderMenuOnMount={true} title={title} className="lang-dropdown d-flex align-items-center" id="lang-dropdown">
            {Object.keys(i18nLangs).map((lang, key) => dropdownItemForLangs(i18nLangs, lang, key, onLangChange))}
        </NavDropdown>
    )
}
